module.exports = __webpack_public_path__ + "static/media/certificado.506627c4.png";